import type { CSSProperties } from 'react';
import { HighlightableButton } from '../button';
import { IconChevronLeft, IconChevronRight, IconDot } from '../icon';
import type { IPageControl } from './PageControl.interface';
import { classNameForElement, StyleElem, styleForElement } from './PageControl.style';

function PageControl(props: IPageControl): JSX.Element {
    const style = (elem: StyleElem, overrides: CSSProperties = {}) =>
        styleForElement(elem, props, overrides);
    const className = (elem: StyleElem) => classNameForElement(elem, props);

    const pageCountIterator = Array(props.totalPages).fill(1);

    return (
        <div
            className={`${props.className ?? ''} ${className(StyleElem.Container)}`}
            style={style(StyleElem.Container, props.style)}
        >
            {props.showArrowButtons && (
                <HighlightableButton
                    highlightable={props.activeIndex > 0}
                    onClick={props.onLeftClick}
                    className={className(StyleElem.ButtonArrowLeft)}
                    style={style(StyleElem.ButtonArrowLeft)}
                >
                    <IconChevronLeft
                        className={className(StyleElem.IconArrowLeft)}
                        style={style(StyleElem.IconArrowLeft)}
                    />
                </HighlightableButton>
            )}
            {pageCountIterator.map((_, idx) => (
                <HighlightableButton
                    key={idx}
                    highlightable={idx !== props.activeIndex}
                    onClick={() => props.onIndexClick?.(idx)}
                    className={className(StyleElem.ButtonDot)}
                    style={style(StyleElem.ButtonDot, {
                        opacity: idx !== props.activeIndex ? 0.5 : 1,
                    })}
                >
                    <IconDot
                        className={className(StyleElem.IconDot)}
                        style={style(StyleElem.IconDot)}
                    />
                </HighlightableButton>
            ))}
            {props.showArrowButtons && (
                <HighlightableButton
                    highlightable={props.activeIndex < props.totalPages - 1}
                    onClick={props.onRightClick}
                    className={className(StyleElem.ButtonArrowRight)}
                    style={style(StyleElem.ButtonArrowRight)}
                >
                    <IconChevronRight
                        className={className(StyleElem.IconArrowRight)}
                        style={style(StyleElem.IconArrowRight)}
                    />
                </HighlightableButton>
            )}
        </div>
    );
}

export default PageControl;
